<a routerLink="/portal">
  <img src="assets/delta-capita-logo.svg" alt="Delta Capita Logo" class="logo" />
</a>
